import { render } from "./PantryFoodInfoView.vue?vue&type=template&id=13596626&ts=true"
import script from "./PantryFoodInfoView.vue?vue&type=script&lang=ts"
export * from "./PantryFoodInfoView.vue?vue&type=script&lang=ts"

import "./PantryFoodInfoView.vue?vue&type=style&index=0&id=13596626&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__